import { gql } from "@apollo/client";

export const GET_CONSULTA_CIERRE_DIFERENCIA_AGRUPADA = gql`
query consultaCierreDiferenciaAgrupada($mes: Int!, $anio: Int!) {
    consultaCierreDiferenciaAgrupada(mes: $mes, anio: $anio) { 
        valorEsperado{
            idConexion
            idMinuta
            cod_Paciente
            paciente
            idEvaluacion
            precioDiario
            idCliente
            cliente
            moduloTipo
            delegacion
            fechaInicio
            fechaFin
            accion
        }
    }
}`;